import { brandExclusions } from './language-brand-exclusions';

// IMPORTANT when update the order, also update the order here => getLanguageCodeShopify()
export const LOCALES = ['en', 'de', 'fr', 'nl', 'es', 'it'] as const;

// IMPORTANT when update the order, also update the order here => getCountryCodeShopify()
// AT is here the international market code (Austria)
export const COUNTRIES = ['NL', 'BE', 'FR', 'DE', 'ES', 'IT', 'AT'] as const;
type ObjectValues<T> = T[keyof T];
export type CountriesType = ObjectValues<typeof COUNTRIES>;

const getFilteredLocalesCountries = (brandName: string | undefined): readonly string[] => {
  const allLocalesCountries = ['nl-be', 'fr-be', 'fr-fr', 'nl-nl', 'de-de', 'es-es', 'it-it', 'en'] as const;

  if (brandName && brandExclusions[brandName]) {
    return allLocalesCountries.filter((locale) => !brandExclusions[brandName].includes(locale));
  }

  return allLocalesCountries;
};

export const LOCALES_COUNTRIES = getFilteredLocalesCountries(process.env['NEXT_PUBLIC_BRAND_NAME']);
export const LOCALES_DEFAULT = 'en';
export const COUNTRIES_DEFAULT = 'be';
export const COUNTRIES_INTERNATIONAL_MARKET = 'at';

export type LocalesCountriesType = ObjectValues<typeof LOCALES_COUNTRIES>;

// Define base-regional pairs centrally for easier management and extension
export const LOCALISED_PAIRS: { [key: string]: string } = {
  'nl-nl': 'nl-be',
  'fr-fr': 'fr-be',
};
